<div class="sync-fusion-main-container">
    <div class="fs-section-block fs-margin-0 header-background">
        <div class="filter-visible">
            <div>
                <span class="mat-headline">Product Listings</span>
                <p class="fs-hint-text">A 360&deg; view of Product Performance</p>
            </div>
            <div class="d-flex mobile_screen">
                <div class="d-flex align-items-center form__fields">
                    <mat-form-field *ngIf="showSearchField" class="floating-icon">
                        <mat-label>Search with Text</mat-label>
                        <div class="search-input">
                            <input matInput [(ngModel)]="search_with_text" (keyup.enter)="searchWithText()"
                                (ngModelChange)="onInputChange($event)">
                            <mat-icon matTooltip="Search" class="click-icon"
                                (click)="searchWithText()">search</mat-icon>
                        </div>
                    </mat-form-field>
                    <div class="toggle-container">
                        <button matTooltip="Grid View" mat-button (click)="setView('grid')"
                            [class.active]="isTableView === false" class="left-button">
                            <mat-icon>grid_on</mat-icon>
                        </button>
                        <button matTooltip="List View" mat-button (click)="setView('table')"
                            [class.active]="isTableView === true" class="right-button">
                            <mat-icon>table_rows</mat-icon>
                        </button>
                    </div>
                    <div *ngIf="showSortField && sortFilterOptions?.length > 0" class="sort-wrapper floating-icon">
                        <mat-form-field class="">
                            <mat-label>Sort by</mat-label>
                            <mat-select [(ngModel)]="sortByOption" (valueChange)="handleValueChange($event)">
                                <mat-option *ngFor="let option of sortFilterOptions" [value]="option.value">
                                    {{option.label}}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                        <div class="click-icon" (click)="sortByAscOrDes()">
                            <mat-icon matTooltip="Low to High" *ngIf="!sortByAsc">arrow_upward</mat-icon>
                            <mat-icon matTooltip="High to Low" *ngIf="sortByAsc">arrow_downward</mat-icon>
                        </div>
                    </div>

                    <button style="height: fit-content;" (click)="showFilters()"
                        class="mat-button mat-primary mat-raised-button">
                        <mat-icon aria-hidden="false" aria-label="Example home icon" fontIcon="filter_alt"></mat-icon>
                        Filters
                    </button>
                </div>
            </div>
        </div>
        <app-reusable-filter-molecule #childFilter *ngIf="filterData" [showFiltersPopup]="showFiltersPopup"
            [reportName]="reportName" [filterData]="filterData" (filterPopupClosed)="showFiltersPopup = $event"
            (filtersApplied)="handleFilterOutput($event)"
            (displayFilters)="selectedFilters($event)"></app-reusable-filter-molecule>
    </div>

    <app-filter-bay-reusable *ngIf="appliedFilters" [addFilters]="appliedFilters"></app-filter-bay-reusable>
    <div *ngIf="!isTableView" class="grid-container mt-1">
        <div #productContainer>
            <div class="product-grid fs-section-block">
                <ng-container *ngIf="loading; else productGrid">
                    <div class="loading-spinner">Loading Products...</div>
                </ng-container>

                <ng-template #productGrid>
                    <ng-container *ngIf="gridList && gridList.length > 0; else noProducts">
                        <ng-container *ngFor="let item of gridList">
                            <div class="product-grid-item" [attr.data-code]="item.product"
                                (contextmenu)="onRightClick($event, item)">
                                <app-product-card-molecule [item]="item"
                                    [showAdditionalInfo]="false"></app-product-card-molecule>
                            </div>
                        </ng-container>
                    </ng-container>
                    <!-- Template for "No Products Found" -->
                    <ng-template #noProducts>
                        <div class="no-products-found">
                            No Products Found for "{{ search_with_text }}"
                        </div>
                    </ng-template>
                </ng-template>
            </div>
        </div>
    </div>
    <div *ngIf="isTableView" class="m-2 grid-container">
        <app-grid-reusable-molecule #gridRef [reportName]="reportName" [dynamic_headers]="dynamic_headers" [count]="count"
            [data]="dataSource" *ngIf="tableDataFetched" (navigateGrid)="navigateGrid($event)"
            (dataEmitForPOPUP)="handlePOPUP($event)"></app-grid-reusable-molecule>

        <app-popup-reuse-organsim *ngIf="fieldData && headerData" [showPOPUP]="visiblePOPUP" [fieldData]="fieldData"
            [headerData]="headerData" (POPUPFeedback)="visiblePOPUP=$event"></app-popup-reuse-organsim>
    </div>
    <mat-paginator *ngIf="this.gridList && this.gridList.length>10 && !isTableView" (page)="clickToNextPage($event)"
        [length]="totalRecordCount" [pageSize]="pageSize" aria-label="Select page">
    </mat-paginator>
</div>